import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-fd-unauthenticated-card',
  standalone: true,
  imports: [
    MatCardModule
  ],
  templateUrl: './fd-unauthenticated-card.component.html',
  styleUrl: './fd-unauthenticated-card.component.scss'
})
export class FdUnauthenticatedCardComponent {

}
